import { regexExp } from '@business/rules/regex';
import * as yup from 'yup';

export type FriendsFormData = {
  friendsName: string;
  friendType: string;
  nickName: string;
  gender: string;
  birthday: string;
  birthPlace: string;
  mutualFriend: string;
  diary: string;
  isPrivate: boolean;
  email: string;
};

export const friendsFormSchema = yup.object().shape({
  friendsName: yup
    .string()
    .required('Friend name is required')
    .trim()
    .min(1, 'Friend name cannot be empty'),
  friendType: yup
    .string()
    .when('$skipConditionalRequired', ([skipConditionalRequired]) => {
      return !Boolean(skipConditionalRequired)
        ? yup.string().required('Friend type is required')
        : yup.string().notRequired();
    }),
  gender: yup
    .string()
    .when('$skipConditionalRequired', ([skipConditionalRequired]) => {
      return !Boolean(skipConditionalRequired)
        ? yup.string().required('Gender is required')
        : yup.string().notRequired();
    }),
  nickName: yup.string().trim(),
  birthday: yup.string(),
  birthPlace: yup.string().trim(),
  mutualFriend: yup.string(),
  diary: yup.string().trim(),
  isPrivate: yup.boolean(),
  email: yup
    .string()
    .trim()
    .nullable()
    .notRequired()
    .test(
      'email-or-empty',
      'Please enter a valid email address',
      value => !value || regexExp.emailRegex.test(value)
    )
});
